import { gql } from "@apollo/client";

export const GET_USER_NOTIFICATIONS = gql(`
    query UserNotification(
      $where: UserWhereUniqueInput!
      $orderBy: [NotificationOrderByWithRelationAndSearchRelevanceInput!]
      $take: Int
      $skip: Int
      $notificationsWhere2: NotificationWhereInput
    ) {
      user(where: $where) {
        id
        countNotification
        Notifications(
          orderBy: $orderBy
          take: $take
          skip: $skip
          where: $notificationsWhere2
        ) {
          body_en
          body_fr
          data
          id
          read
          title_en
          receiverId
          title_fr
          type
          createdAt
        }
      }
    }
  `);

export const GET_USER = gql(`
  query User(
    $where: UserWhereUniqueInput!
    $orderBy: [NotificationOrderByWithRelationAndSearchRelevanceInput!]
    $take: Int
    $skip: Int
  ) {
    user(where: $where) {
      id
      lastName
      name
      role
      minQuantityOrder
      country {
        name_fr
      }
      ProfilePhoto {
        id
        url
        name
      } 
      UserAddresses {
        id
        address
        cityName
        zipCode
        isActive
        Country {
          id
          name_en
          name_fr
          currency
        }
      }
    } 
  }
`);

export const USER = gql(`
    query GetCustomerMessage($where: UserWhereUniqueInput!) {
      user(where: $where) {
        id
        country {
          id
          currency
          minPrice
        }
      }
    }
  `);

export const GET_CUSTOMER_FAVORITES = gql(`
  query UserFavoris(
    $where: UserWhereUniqueInput!
    $orderBy: [FavoritesOrderByWithRelationAndSearchRelevanceInput!]
    $take: Int
    $skip: Int
    $aggregateFavoritesWhere2: FavoritesWhereInput
  ) {
    user(where: $where) {
      id
      CustomerFavorites(orderBy: $orderBy, take: $take, skip: $skip) {
        id
        Craftman {
          isFavoris
          id
          lastName
          name
          workshopName
          lang
          yearOfExperience
          minQuantityOrder
          Categories {
            id
            name_en
            name_fr
          }
          PhotoAchievements {
            id
            url
            name
          }
          ProfilePhoto {
            id
            url
            name
          }
          country {
            id
            name_en
            name_fr
            currency
          }
        }
      }
    }
    aggregateFavorites(where: $aggregateFavoritesWhere2) {
      _count {
        _all
      }
    }
  }
`);

export const USER_INFOS = gql(`
  query UserInfos(
    $where: UserWhereUniqueInput!
  ) {
    user(where: $where) {
      id
      lastName
      name
      email
      phoneNumber
      city
      ProfilePhoto {
        id
        url
        name
      }
      country {
        id
        name_en
        name_fr
        currency
      }
      UserAddresses {
        id
        address
        cityName
        zipCode
        isActive
        Country {
          id
          name_en
          name_fr
          currency
        }
      }
    }
  }
`);

export const USER_ADDRESS = gql(`
  query UserAddresses($where: UserWhereUniqueInput!) {
    user(where: $where) {
      id
      UserAddresses {
        id
        address
        cityName
        zipCode
        isActive
        Country {
          id
          name_en
          name_fr
          currency
        }
      }
    }
  }
`);

export const CREATE_USER_ADDRESS = gql(`
  mutation CreateNewAdress($data: CreateNewAdressInput!) {
    createNewAdress(data: $data) {
      cityName
      id
      isActive
      zipCode
      address
      Country {
        id
        name_en
        name_fr
        currency
      }
    }
  }
`);


export const UPDATE_USER_ACCOUNT = gql(`
  mutation UpdateUserAccount($updateUserInput: UpdateUserInput!) {
    updateUserAccount(updateUserInput: $updateUserInput) {
      token
      user {
        id
        lastName
        name
        email
        phoneNumber
        city
        customerRole
        activeNotif
        country {
          id
          name_en
          name_fr
        }
      }
    }
  }
`);
